import VuexPersistence from 'vuex-persist'

export default ({ store }) => {
  window.onNuxtReady(() => {
    new VuexPersistence({
      key: 'JitStorage',
      storage: window.localStorage,
      reducer: state => ({
        facturacion: {
          types: {
            provincia: state.facturacion.types.provincia,
            canton: state.facturacion.types.canton,
            distrito: state.facturacion.types.distrito,
            tipoIdentificacion: state.facturacion.types.tipoIdentificacion,
            codigoActividad: state.facturacion.types.codigoActividad,
            documento: state.facturacion.types.documento,
            codigoReferencia: state.facturacion.types.codigoReferencia,
            condicionVenta: state.facturacion.types.condicionVenta,
            impuesto: state.facturacion.types.impuesto,
            medioPago: state.facturacion.types.medioPago,
            mensaje: state.facturacion.types.mensaje,
            moneda: state.facturacion.types.moneda,
            situacionComprobante: state.facturacion.types.situacionComprobante,
            tarifa: state.facturacion.types.tarifa,
            tipoProducto: state.facturacion.types.tipoProducto,
            unidadMedida: state.facturacion.types.unidadMedida,
            institucionExoneracion: state.facturacion.types.institucionExoneracion
          }
        }
      })
    }).plugin(store)
  })
}
